const filterRecentSearchList = (recentSearches) =>
  recentSearches.filter((recentSearch) => {
    const {
      formData: { originationAirportCode, destinationAirportCode, returnAirportCode },
    } = recentSearch;

    return (
      destinationAirportCode !== undefined &&
      originationAirportCode !== undefined &&
      returnAirportCode !== undefined &&
      !Array.isArray(destinationAirportCode) &&
      !Array.isArray(originationAirportCode) &&
      !Array.isArray(returnAirportCode)
    );
  });

export { filterRecentSearchList };
